import React, { useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import famIcon01 from '../../images/fam_icon01.png';
import famIcon02 from '../../images/fam_icon02.png';
import famIcon03 from '../../images/fam_icon03.png';
import famIcon04 from '../../images/fam_icon04.png';
import famIcon05 from '../../images/fam_icon05.png';
import famIcon06 from '../../images/fam_icon06.png';
import famIcon07 from '../../images/fam_icon07.png';

export default function FireOnToolbar(props) {
    let { id } = useParams();
    const [selectedItem, setSelectedItem] = useState(props.item);

    const toolbarItems = [
        { linkTo: `/fire-on/alarm-monitor/${id}`, title: '화재수신기 모니터', img: famIcon01 },
        { linkTo: `/fire-on/boundary-map/${id}`, title: '경계구역일람도', img: famIcon02 },
        { linkTo: `/fire-on/building-status/${id}`, title: '건축물현황', img: famIcon03 },
        { linkTo: `/fire-on/equipment-status/${id}`, title: '소방시설현황', img: famIcon04 },
        { linkTo: `/fire-on/alarm-history/${id}`, title: '화재경보 발생이력', img: famIcon05 },
        { linkTo: `/fire-on/alarm-statistics/${id}`, title: '통계 레포트', img: famIcon06 },
        { linkTo: `/fire-on/sms-history-list/${id}`, title: 'SMS 전송이력', img: famIcon07 },
    ];

    return (
        <div className="toolbar gnbToolbar" style={{ display: 'flex' }}>
            <div className="wrap_inner">
                {toolbarItems.map((item, index) => (
                    <Link
                        className={`btn_tb ${selectedItem === item.title ? 'now' : ''}`}
                        key={index}
                        to={item.linkTo}
                        state={{
                            buildingName: props.buildingName,
                            serialNumber: props.serialNumber,
                            dei: props.dei
                        }}
                        onClick={() => setSelectedItem(item.title)}
                        onMouseEnter={(e) => e.currentTarget.classList.add('active')}
                        onMouseLeave={(e) => e.currentTarget.classList.remove('active')}
                    >
                        <div className={`title_bubble bubble_0${index + 1}`}>
                            <p>{item.title}</p>
                        </div>
                        <div className="wrap_icon">
                            <img src={item.img} alt={item.title} />
                        </div>
                    </Link>
                ))}
            </div>
        </div>
    );
}